import { Close } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import {
    Box,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Skeleton,
    Typography,
} from '@mui/material';
import React from 'react';
const WaitListPreviewLoading = () => {
    return (
        <>
            <DialogTitle>
                <Skeleton variant='text' height={30} width={100} />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: 'text.primary',
                    }}
                >
                    <EditIcon
                        fontSize='small'
                        sx={{
                            fontSize: '16px',
                            cursor: 'pointer',
                        }}
                    />

                    <IconButton size='small' aria-label='close'>
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers sx={{ px: 3 }}>
                <Grid container spacing={2}>
                    <Grid item container xs={12}>
                        <Grid item xs={12} sm={3.5}>
                            <Typography
                                fontSize='14px'
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Start Date:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8.5}>
                            <Skeleton variant='text' height={30} width={200} />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                        <Grid item xs={12} sm={3.5}>
                            <Typography
                                fontSize='14px'
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                }}
                            >
                                End Date:
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8.5}>
                            <Skeleton variant='text' height={30} width={200} />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} container>
                        <Grid item xs={12} sm={3.5}>
                            {' '}
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Check-in
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={8.5}>
                            <Skeleton variant='text' height={30} width={200} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container>
                        <Grid item xs={12} sm={3.5}>
                            {' '}
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Checkout
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={8.5}>
                            <Skeleton variant='text' height={30} width={200} />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} container>
                        <Grid item xs={12} sm={3.5}>
                            {' '}
                            <Typography
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                }}
                            >
                                Notes
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={8.5}>
                            <Skeleton variant='text' height={30} width={200} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </>
    );
};

export default WaitListPreviewLoading;
